// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setup-confirmation__secret[data-v-3ee9787a]{word-break:break-all}`, "",{"version":3,"sources":["webpack://./src/components/SetupConfirmation.vue"],"names":[],"mappings":"AAEC,6CACC,oBAAA","sourcesContent":["\n.setup-confirmation {\n\t&__secret {\n\t\tword-break: break-all;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
